/**
 * Условие опроса карточки проекта (`GET /api/projects/{id}`).
 *
 * Карточка несёт и статусы генераций кадров (`shots[].gens`), и хронологию ролика со стиллами
 * (`video.timeline`) — ровно то, из чего панель «Ракурсы» рисует «генерируется…» / «готово», а шапка
 * — значок «в очереди и в работе». Соседний опрос вкладки «Видео» (`video.ts`, `useProjectVideo`)
 * считает только клипы и монтажи, поэтому пакет ракурсов шёл мимо него: статус стоял на
 * «генерируется…» до перезагрузки страницы (задача Оли №301).
 *
 * Признак «есть незавершённые» берём с сервера как есть — `ProjectView.pending` (`generate.pending`:
 * генерации кадров проекта в `queued`/`running`, клипы в счёт не идут). Своего счёта по
 * `shots[].gens` не заводим: он разъехался бы с тем, что считает сервер.
 *
 * Без импортов из `@/…`: модуль проверяется `node --test` (tests/projectPoll.test.ts) как есть.
 */

/** Как у соседнего опроса вкладки «Видео» (`useProjectVideo`) — раз в 5 с. */
export const PROJECT_POLL_MS = 5_000;

/**
 * Интервал опроса карточки для `refetchInterval`: пока незавершённые генерации кадров есть — 5 с,
 * не осталось — `false`, то есть готовый экран не опрашивается вхолостую (несущее правило соседних
 * опросов). `undefined` — ответа ещё нет: опрашивать нечего.
 */
export function projectPollMs(pending: number | null | undefined): number | false {
  return (pending ?? 0) > 0 ? PROJECT_POLL_MS : false;
}
